import { createI18n } from 'vue-i18n';
import { messages } from '@/messages';

export const i18n = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: 'de-DE', // set locale
  fallbackLocale: 'de-DE', // set fallback locale
  messages, // set locale messages,
});
